import { environment } from "../../../environments/environment";

export enum CacheAreaKey {
  Products = 'p',
  Account = 'a',
  Customer = 'c',
  Content = 'content',
  Config = '_c',
  Payments = '_p',
}

export const CacheConfig = {
  [CacheAreaKey.Products]: {
    key: CacheAreaKey.Products,
    cacheTimeout: environment.CACHE_TIMEOUT_PRODUCTS,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.Account]: {
    key: CacheAreaKey.Account,
    cacheTimeout: environment.CACHE_TIMEOUT_ACCOUNT,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.Customer]: {
    key: CacheAreaKey.Customer,
    cacheTimeout: environment.CACHE_TIMEOUT_CUSTOMER,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.Content]: {
    key: CacheAreaKey.Content,
    cacheTimeout: environment.CACHE_TIMEOUT_CONTENT,
    debounceCacheTime: null,
  },
  [CacheAreaKey.Payments]: {
    key: CacheAreaKey.Payments,
    cacheTimeout: environment.CACHE_TIMEOUT_PAYMENTS,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.Config]: {
    key: CacheAreaKey.Config,
    cacheTimeout: environment.CACHE_TIMEOUT_CONFIG,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  }
}